import { formatData, formatDataSchemas } from "./utils";


export function fetchAlerts(){
    return async function(dispatch){
        try{
            console.log("FETCH ALERTS START")
            const response = await fetch('/alerts/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let res = await response.json();
            console.log({res});
            let list = res.list            
            // let list = [
            //     {
            //         "alert_id": "1582887939-diW2lG4ZbtTRRRtHEXD",
            //         "type": "alertManagementDescriptionList",
            //         "account_id": "1544132674-E6olId9IL2Ghx7s",
            //         "alert_name": "Paiement confirmation - Pico",
            //         "alert_type": "payment",
            //         "alert_creation_date": "2020-02-28T11:05:39.043507746Z",
            //         "message": "{{amount_paid}} recu pour {{id_product}} Code: {{code_product}} Total payé {{total_paid}} Solde restant {{rest_topay}} ARESS BK vous remercie",
            //         "info": "{\"startVal\":\"\",\"stopVal\":\"\"}",
            //         "subID": [
            //             "ALL"
            //         ],
            //         "status": "ON"
            //     }
            // ]           
            
            if (list){
                dispatch({
                    type: "GET_ALERTS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch ALERTS ", err);
        }
    }
}
export function deleteAlert(alert){
    return async function(dispatch){
        try{
            console.log("DELETE ALERTS START")
            const response = await fetch('/alerts/delete',{
                method:'DELETE',
                body: JSON.stringify({alert_id: alert.alert_id}),
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let res = await response.json();
                     
            
            if (res){
                dispatch({
                    type: "DELETE_ALERTS",
                    payload: alert.alert_id
                })
            }
        } catch(err) {
            console.log("[ERROR] delete ALERTS ", err);
        }
    }
}

export function fetchAgents(){
    return async function(dispatch){
        try{
            console.log("FETCH AGENTS START")
            const response = await fetch('/agent/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let res = await response.json();
            console.log({res});
            let list = res.contentJs            
            
            if (list){
                list = formatData(list.reverse())
                dispatch({
                    type: "GET_AGENTS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch AGENTS ", err);
        }
    }
}
export function updateAgent(agent){
    return async function(dispatch){
        try{
            console.log("UPDATE AGENT START")
            const response = await fetch('/installer/getMoreInfo',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    role_id: agent.extraID,
                    user_id: agent.id
                }),
                credentials: 'same-origin',
            });
            let infos = await response.json();
            console.log({infos});
            
            if (infos.error === "OK"){
                dispatch({
                    type: "UPDATE_AGENT",
                    payload: {
                        id: agent.id,
                        data: infos.formData
                    }
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch AGENTS ", err);
        }
    }
}
export function fetchInstallers(){
    return async function(dispatch){
        try{
            console.log("FETCH installer START")
            const res = await fetch('/installer/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.contentJs

            if (list){
                list = formatData(list.reverse())
                dispatch({
                    type: "GET_INSTALLERS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch installer ", err);
        }
    }
}
export function updateInstaller(installer){
    return async function(dispatch){
        try{
            console.log("UPDATE INSTALLER START")
            const response = await fetch('/installer/getMoreInfo',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    role_id: installer.extraID,
                    user_id: installer.id
                }),
                credentials: 'same-origin',
            });
            let infos = await response.json();
            console.log({infos});
            
            if (infos.error === "OK"){
                dispatch({
                    type: "UPDATE_INSTALLER",
                    payload: {
                        id: installer.id,
                        data: infos.formData
                    }
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch INSTALLERS ", err);
        }
    }
}
export function fetchSchemas(){
    return async function(dispatch){
        try{
            console.log("FETCH schema START")
            const res = await fetch('/schema/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatDataSchemas(list.reverse(), "Agent")
                dispatch({
                    type: "GET_SCHEMAS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch schema ", err);
        }
    }
}
export function fetchReportSchemas(){
    return async function(dispatch){
        try{
            console.log("FETCH report schema START")
            const res = await fetch('/schema/maintenance/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatDataSchemas(list.reverse(), "Panne")
                // DISPATCH
                dispatch({
                    type: "GET_REPORT_SCHEMAS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch report schema ", err);
        }
    }
}
export function fetchQuotationSchemas(){
    return async function(dispatch){
        try{
            console.log("FETCH quotation schema START")
            const res = await fetch("/schema/quotation/list",{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatDataSchemas(list.reverse(), "Visite")
                // DISPATCH
                dispatch({
                    type: "GET_QUOTATION_SCHEMAS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch quotation schema ", err);
        }
    }
}
export function fetchSavSchemas(){
    return async function(dispatch){
        try{
            console.log("FETCH sav schema START")
            const res = await fetch("/schema/sav/list",{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatDataSchemas(list.reverse(), "SAV")
                // DISPATCH
                dispatch({
                    type: "GET_SAV_SCHEMAS",
                    payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch sav schema ", err);
        }
    }
}
// export function fetchSubscriptions(){
    //     return async function(dispatch){
    //         try{
    //             console.log("FETCH SUBSCRIPTIONS START")
    //             const res = await fetch('/subscription/list',{
    //                 method:'GET',
    //                 headers: new Headers({ 
    //                     'Content-Type': 'application/json',
    //                     //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
    //                 }),
    //                 credentials: 'same-origin',
    //             })
    //             let list = await res.json();
    //             console.log({list});
                
    //             if (list){
    //                 list = formatData(list.reverse())
    //                 // DISPATCH
    //             }
    //         } catch(err) {
    //             console.log("[ERROR] refetch SUBSCRIPTIONS ", err);
    //         }
    //     }
// }
export function fetchSims(){
    return async function(dispatch){
        try{
            console.log("FETCH SIMS START")
            const res = await fetch('/sim/list?status=disable',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.contentJs
            
            if (list){
                list = formatData(list.reverse())
                dispatch({
                    type: "GET_SIMS", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch SIMS ", err);
        }
    }
}
export function fetchBoxes(){
    return async function(dispatch){
        try{
            console.log("FETCH BOX START")
            const res = await fetch('/association/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.contentJs
            
            if (list){
                list = formatData(list.reverse(), "idBox")
                dispatch({
                    type: "GET_BOXES", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch BOX ", err);
        }
    }
}
export function fetchFreeBoxes(){
    return async function(dispatch){
        try{
            console.log("FETCH BOX free START")
            const res = await fetch('/box/list?status=configured',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatData(list.reverse(), "idBox")
                dispatch({
                    type: "GET_FREE_BOXES", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch BOX ", err);
        }
    }
}
export function fetchLinkedBoxes(){
    return async function(dispatch){
        try{
            console.log("FETCH BOX free START")
            const res = await fetch('/box/list?status=linked',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatData(list.reverse(), "idBox")
                dispatch({
                    type: "GET_LINKED_BOXES", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch BOX ", err);
        }
    }
}
export function fetchUsers(){
    return async function(dispatch){
        try{
            console.log("FETCH Users START")
            const res = await fetch('/userRole/userList',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.roleList
            
            if (list){
                list = formatData(list.reverse(), "email")
                dispatch({
                    type: "GET_USERS", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] fetch USERS ", err);
        }
    }
}
export function fetchRoles(){
    return async function(dispatch){
        try{
            console.log("FETCH Roles START")
            const res = await fetch('/userRole/roleList',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.roleList
            
            if (list){
                list = formatData(list.reverse())
                dispatch({
                    type: "GET_ROLES", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] fetch ROLES ", err);
        }
    }
}

export function fetchSms(){
    return async function(dispatch){
        try{
            console.log("FETCH SMS START")
            const res = await fetch('/message/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let resp = await res.json();
            console.log({resp});
            let list = resp.content
            
            if (list){
                list = formatData(list.reverse(), "timeSent")
                dispatch({
                    type: "GET_SMS", payload: list
                })
            }
        } catch(err) {
            console.log("[ERROR] refetch SMS ", err);
        }
    }
}
export function fetchSmsPaginated(offset, limit, search){
    return async function(){
        try{
            const params = new URLSearchParams({
                offset: offset || 0,
                limit: limit || 25,
                search: search || "",
            })
            const res = await fetch(`/message/list/paginated?${params.toString()}`,{
                method:'GET',
                headers: new Headers({ 'Content-Type': 'application/json' }),
                credentials: 'same-origin',
            })
            const resp = await res.json();
            return {
                content: Array.isArray(resp.content) ? resp.content : [],
                total: resp.total || 0,
            }
        } catch(err) {
            console.log("[ERROR] fetchSmsPaginated ", err);
            return { content: [], total: 0 }
        }
    }
}
export function fetchCredit(){
    return async function(dispatch){
        try{
            console.log("FETCH CREDIT START")
            const res = await fetch('/credit/sms',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let sms = await res.json();
            console.log({sms});
            
            const res2 = await fetch('/credit/amount',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let amount = await res2.json();
            console.log({amount});
            if( sms.content && amount.content){
                let infos = {
                    creditSMS:sms.content.number || 0,
                    creditAmount:amount.content.amount || 0,
                    creditCurrency:amount.content.currency || "",
                }      
                dispatch({
                    type: "GET_CREDIT", payload: infos
                })
            } 
            // ELSE ERROR
        } catch(err) {
            console.log("[ERROR] fetch CREDIT ", err);
        }
    }
}
export function fetchCreditList(){
    return async function(dispatch){
        try{
            console.log("FETCH CREDIT LIST START")
            const res = await fetch('/credit/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let transactionList = await res.json();
            console.log({transactionList});
            
            
            if( transactionList.content){
                dispatch({
                    type: "GET_CREDIT_LIST", payload: transactionList.content
                })
            } 
            // ELSE ERROR
        } catch(err) {
            console.log("[ERROR] fetch CREDIT LIST ", err);
        }
    }
}